import React, {useEffect} from "react";
import InputLabel from "@mui/material/InputLabel";
import {FormControl} from "@mui/material";
import {isEmpty, isObject, isArray} from "../../util/is";
import {Controller, useController, useFormContext, useWatch} from "react-hook-form";
import Select from "react-select";
import {convertToString, validArray} from "../../util/functions";
import { components, StylesConfig  } from 'react-select';
import Tooltip from "@mui/material/Tooltip";

let allOption = {
  text: "Todos",
  id: "*"
}

const colourStyles: StylesConfig<ColourOption, true> = {
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
          ? "rgba(25, 118, 210, 0.18)"
          : isFocused
            ? "transparent"
            : undefined,
      color: isDisabled
        ? '#ccc'
        : 'black',
      fontWeight: isSelected ?
        'bold' : 'normal',
      cursor: isDisabled ? 'not-allowed' : 'default',

      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled
          ? isSelected
            ? "rgba(25, 118, 210, 0.18)"
            : "rgba(25, 118, 210, 0.18)"
          : undefined,
      },
    
    };
  },
  singleValue: (provided, { data }) => ({
    ...provided,
    color: 'hsl(0, 0%, 10%)' 
  }),
};

const MoreSelectedBadge = ({ items }) => {
  const style = {
    marginLeft: "auto",
    background: "#d4eefa",
    borderRadius: "4px",
    fontFamily: "Open Sans",
    fontSize: "11px",
    padding: "3px",
    order: 99
  };

  const title = items.join(", ");
  const length = items.length;
  const label = `+ ${length}`;

  return (
    <div style={style} title={title}>
      {label}
    </div>
  );
};

const MultiValue = ({ index, getValue, ...props }) => {
  const maxToShow = 1;
  const overflow = getValue()
    .slice(maxToShow)
    .map((x) => x.text);

  return index < maxToShow ? (
    <components.MultiValue {...props} />
  ) : index === maxToShow ? (
    <MoreSelectedBadge items={overflow} />
  ) : null;
};


const SelectFormVirtualizeController = ({ required, inputProps, identificador, isMulti, showId, disabled, isSearchable, options, placeHolder, width, todoSelect}) => {

  const { setValue, control } = useFormContext();

  const currentValue = useWatch({
    name: identificador,
    control
  })

  const changeSelectController = (value, onChange) => {

    if(isMulti){
      if (value[value.length - 1]?.id === allOption?.id) {
        let arrOptions = [];
        let optionsNew = (value.length - 1) === options.length ? [] : options
        for(let item of optionsNew){
          arrOptions.push(item);
        }
        onChange(arrOptions);
        //event.target.value = arrOptions.slice();
      }
      else{
        onChange(value);
      }
      return;
    }

    onChange(value);

  }

  const getOptionSelected = (value, onChange) => {

    if(isEmpty(value)){
      return "";
    }

    if(isArray(value)){
      return value;
    }

    let objValueTemp = isObject(value) ? value.id : value;
    let opcionSeleccionada = options.find(item => convertToString(item.id) === convertToString(objValueTemp))

    if(!opcionSeleccionada){
      return "";
    }

    return opcionSeleccionada;

  }

  useEffect(() => {
    if(!isEmpty(currentValue) && !isEmpty(setValue) && (typeof currentValue === "string" || typeof currentValue === "number") && ('control' in inputProps)){
      setValue(identificador, getOptionSelected(currentValue));
    }
  }, [currentValue])


  return(
    <Controller
      rules={{ required: required }}
      control={inputProps.control}
      defaultValue={""}
      name={identificador}
      render={({ field: { onChange, onBlur, value } }) =>
        (
          <Select
            closeMenuOnSelect={!isMulti}
            hideSelectedOptions={false}
            name={identificador}
            className={`mx-1 calendarClass w-100`}
            hasValue={false}
            isMulti={isMulti}
            getOptionLabel={option => showId ? `${option.id} - ${option.text}` : option.text}
            getOptionValue={option => option.id}
            isClearable={true}
            isDisabled={disabled}
            isSearchable={isSearchable}
            onBlur={onBlur}
            value={getOptionSelected(value, onChange)}
            onChange={(event, event2) => changeSelectController(event, onChange, event2)}
            options={isMulti && todoSelect ? [allOption, ...options] : options}
            components={isMulti ? { MultiValue } : {}}
            style={{width, boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)'}} placeholder={placeHolder}
            styles={colourStyles}
          />
        )
      }
    />
  )

}


const SelectFormVirtualize = ({identificador, label , value , options = [], handleChange, width = `100%`, disabled = false, className="classDefaultForm", required = false,
                                inputProps = {}, placeHolder="Seleccione", customError = null, showId = true, isMulti = false, closeMenuOnSelect = true, isSearchable = true, todoSelect = true}) => {

    const changeSelectManual = (value) =>{

      if(isMulti){
        if (value[value.length - 1] === allOption.id) {
          let arrOptions = [];
          let optionsNew = (value.length - 1) === options.length ? [] : options
          for(let item of optionsNew){
            arrOptions.push(convertToString(item));
          }
          handleChange({name: identificador, value: arrOptions.slice()})
          return;
        }
      }

      handleChange({name: identificador, value});

    }

    const getOptionSelected = (value, onChange) => {

      if(isEmpty(value)){
        return "";
      }

      if(isArray(value)){
        return value;
      }

      let objValueTemp = isObject(value) ? value.id : value;
      let opcionSeleccionada = options.find(item => convertToString(item.id) === convertToString(objValueTemp))

      if(!opcionSeleccionada){
        return "";
      }

      return opcionSeleccionada;

    }

    return(
        <FormControl key={`key${identificador}`} variant="outlined" className={`my-1 ${className}`}>
          <Tooltip title={`${required ? `*${label}` : `${label}`}`}>
            <InputLabel shrink htmlFor={identificador} style={{width, fontWeight: 'bold', textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", pointerEvents: "auto"}}>{`${required ? `*${label}` : `${label}`}`}</InputLabel>
          </Tooltip>
            { !('control' in inputProps) ?
                <Select
                  closeMenuOnSelect={!isMulti}
                  hideSelectedOptions={false}
                  name={identificador}
                  value={getOptionSelected(value, handleChange)}
                  className={`mx-1 calendarClass w-100`}
                  getOptionValue={option => option.id}
                  getOptionLabel={option => showId ? `${option.id} - ${option.text}` : option.text}
                  isClearable={true}
                  isDisabled={disabled}
                  hasValue={true}
                  isMulti={isMulti}
                  isSearchable={isSearchable}
                  onChange={(value) => changeSelectManual(value)}
                  options={isMulti && todoSelect ? [allOption, ...options] : options}
                  style={{width, boxShadow: '0 2px 5px 0 rgb(0 0 0 / 4%)'}} placeholder={placeHolder}
                  components={isMulti ? { MultiValue } : {}}
                  styles={colourStyles}
                />
                :
                <SelectFormVirtualizeController showId={showId} disabled={disabled} required={required} identificador={identificador}
                                                inputProps={inputProps} isMulti={isMulti} isSearchable={isSearchable}
                                                options={options} placeHolder={placeHolder} width={width} todoSelect={todoSelect}/>

            }
            {
              (!isEmpty(customError) || required) &&
                <span className="mt-1 pl-2 titleForm panelColorError">{customError}</span>
            }
        </FormControl>
    )

}

export default SelectFormVirtualize;
